var _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.4942 0H11.4942C14.2552 0 16.4942 2.239 16.4942 5V11C16.4942 13.761 14.2552 16 11.4942 16H5.4942C2.7332 16 0.494202 13.761 0.494202 11V5C0.494202 2.239 2.7332 0 5.4942 0ZM11.4942 14.5C13.4242 14.5 14.9942 12.93 14.9942 11V5C14.9942 3.07 13.4242 1.5 11.4942 1.5H5.4942C3.5642 1.5 1.9942 3.07 1.9942 5V11C1.9942 12.93 3.5642 14.5 5.4942 14.5H11.4942Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.4942 8C4.4942 5.791 6.2852 4 8.4942 4C10.7032 4 12.4942 5.791 12.4942 8C12.4942 10.209 10.7032 12 8.4942 12C6.2852 12 4.4942 10.209 4.4942 8ZM5.9942 8C5.9942 9.378 7.1162 10.5 8.4942 10.5C9.8722 10.5 10.9942 9.378 10.9942 8C10.9942 6.621 9.8722 5.5 8.4942 5.5C7.1162 5.5 5.9942 6.621 5.9942 8Z",
    fill: "#333333"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.7942,
    cy: 3.69999,
    r: 0.533,
    fill: "#333333"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.103242db7cfe0a64641519357cc7f482.svg";
export { ForwardRef as ReactComponent };